import axiosInstance from "./AxiosInstance";

export default {
    get() {
        return axiosInstance({
            method: "get",
            url: "/driver_registrations",
        });
    },
    getByDate(from, to) {
        return axiosInstance({
            method: "get",
            url: `/driver_registrations/list/by_dates/${from}/${to}`,
        });
    },

    update(id, body) {
        return axiosInstance({
            method: "patch",
            url: `/driver_registrations/${id}`,
            data: body,
        });
    },

    updateStatus(id, status) {
        return axiosInstance({
            method: "patch",
            url: `/driver_registrations/expected/${id}/${status}`,
        });
    },
};
